(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 43832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, color !== 'default' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var SvgComponent = function SvgComponent() {
  var w = 31;
  var h = 31;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "back arrow",
    width: w,
    height: h,
    viewBox: "0 0 31 31",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
      "data-name": "Ellipse 6",
      cx: "15.5",
      cy: "15.5",
      r: "15.5",
      fill: "#f7f7f7"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "data-name": "Path 603",
      d: "M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 78434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/Icons/BackIcon.tsx
var BackIcon = __webpack_require__(2936);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icons/MinusIcon.tsx



var SvgComponent = function SvgComponent(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.4",
    height: "1.4",
    viewBox: "0 0 15.4 1.4",
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      "data-name": "plus icon",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2308",
        d: "M1 11h14",
        transform: "translate(-.3 -10.3)",
        fill: "none",
        stroke: "#264f36",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.4px"
      })
    })
  });
};

/* harmony default export */ var MinusIcon = (SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/PlusIcon.tsx




var PlusIcon_SvgComponent = function SvgComponent(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.4",
    height: "15.4",
    viewBox: "0 0 15.4 15.4",
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      "data-name": "plus icon",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2308",
        d: "M1 11h14",
        transform: "translate(-.3 -3.3)",
        fill: "none",
        stroke: "#264f36",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.4px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 2309",
        d: "M11 1v14",
        transform: "translate(-3.3 -.3)",
        fill: "none",
        stroke: "#264f36",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.4px"
      })]
    })
  });
};

/* harmony default export */ var PlusIcon = (PlusIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Faq/FaqWrapper.tsx









var StyledQuestionBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "FaqWrapper__StyledQuestionBox",
  componentId: "sc-p16t4f-0"
})(["border-top:1px solid #264f36;display:flex;justify-content:space-between;align-items:center;height:66px;cursor:pointer;svg{cursor:pointer;margin-left:10px;}:hover{text-decoration:underline;}"]);
var StyledQuestion = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body2"
}).withConfig({
  displayName: "FaqWrapper__StyledQuestion",
  componentId: "sc-p16t4f-1"
})(["color:#264f36;font-weight:", ";"], function (p) {
  return p.$expand ? "bold" : "100";
});
var StyledAnswer = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "FaqWrapper__StyledAnswer",
  componentId: "sc-p16t4f-2"
})(["text-align:right;padding-bottom:20px;margin-right:10px;"]);

var FaqWrapper = function FaqWrapper(_ref) {
  var question = _ref.question,
      answer = _ref.answer,
      key = _ref.key;

  var _useState = (0,react.useState)(false),
      expand = _useState[0],
      setExpand = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledQuestionBox, {
      onClick: function onClick() {
        return setExpand(!expand);
      },
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter") setExpand(!expand);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledQuestion, {
        $expand: expand,
        children: question
      }), expand ? /*#__PURE__*/(0,jsx_runtime.jsx)(MinusIcon, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(PlusIcon, {})]
    }, key), expand && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAnswer, {
      children: answer
    })]
  });
};

/* harmony default export */ var Faq_FaqWrapper = (FaqWrapper);
;// CONCATENATED MODULE: ./components/Faq/FaqPage.tsx














var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "FaqPage__StyledBox",
  componentId: "sc-msgnly-0"
})(["margin-top:120px;padding-left:60px;padding-right:60px;margin-bottom:120px;", "{margin-top:94px;padding-left:16px;padding-right:16px;margin-bottom:60px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FaqPage__StyledLink",
  componentId: "sc-msgnly-1"
})(["display:flex;cursor:pointer;p{margin-right:8px;}:hover{text-decoration:underline;}"]);
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "FaqPage__StyledTitle",
  componentId: "sc-msgnly-2"
})(["font-size:40px;color:#000;margin-bottom:20px;text-align:right;line-height:1;margin-top:30px;", "{text-align:right;margin-top:20px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "FaqPage__StyledWrapper",
  componentId: "sc-msgnly-3"
})(["", "{padding-left:12%;padding-right:12%;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledIconBtn = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
  displayName: "FaqPage__StyledIconBtn",
  componentId: "sc-msgnly-4"
})(["padding:1px;position:relative;bottom:2px;"]);

var FaqPage = function FaqPage(_ref) {
  var setRefList = _ref.setRefList;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      data = _useState[0],
      setData = _useState[1];

  var Section1Ref = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    setRefList([Section1Ref]);

    var getFaqs = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _yield$getGiftCardGet, data, sorted;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,api.getGiftCardGetFAQ)();

              case 2:
                _yield$getGiftCardGet = _context.sent;
                data = _yield$getGiftCardGet.data;
                sorted = data === null || data === void 0 ? void 0 : data.body.sort(function (a, b) {
                  return a.order - b.order;
                });
                setData(sorted);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getFaqs() {
        return _ref2.apply(this, arguments);
      };
    }();

    getFaqs();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBox, {
    ref: Section1Ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLink, {
      onClick: function onClick() {
        return router.back();
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter") router.back();
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconBtn, {
        "aria-label": "\u05D7\u05D6\u05E8\u05D4 \u05DC\u05E2\u05DE\u05D5\u05D3 \u05E7\u05D5\u05D3\u05DD",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackIcon/* default */.Z, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "body1",
        children: "\u05D7\u05D6\u05E8\u05D4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
        children: "שאלות ותשובות בנושא גיפטקארד מקדונלד'ס"
      }), data.map(function (data, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Faq_FaqWrapper, {
          question: data.question,
          answer: data.answer
        }, index);
      })]
    })]
  });
};

/* harmony default export */ var Faq_FaqPage = (FaqPage);
;// CONCATENATED MODULE: ./src/pages/faq.tsx







var Faq = function Faq() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useState = (0,react.useState)([]),
      refList = _useState[0],
      setRefList = _useState[1];

  var seo = {
    title: "עמוד שאלות ותשובות לגיפטקארד מקדונלדס",
    description: "עמוד שבו אפשר למצוא שאלות ותשובות לגיפטקארד מקדונלדס",
    keywords: "שאלות ותשובות ,גיפטקארד, מקדונלדס"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Faq_FaqPage, {
      setRefList: setRefList
    })]
  });
};

/* harmony default export */ var faq = (Faq);

/***/ }),

/***/ 50008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(78434);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2726,9774,2888,179], function() { return __webpack_exec__(50008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);